import React, {useContext, useEffect, useState} from "react";

export const LayoutContext = React.createContext(null);

export const LayoutDefine = {
    main: 1,
    /** V1 Economic settings only (legacy X header + sidebar) */
    legacySettings: 2,
};

export const UseMainLayout = () => {
    UseLayout(LayoutDefine.main);
};

export const UseLegacySettingsLayout = () => {
    UseLayout(LayoutDefine.legacySettings);
};

/** @deprecated V1 Economic only — alias kept so EconomicV1 stays frozen */
export const UseSecondLayout = UseLegacySettingsLayout;

const UseLayout = (l) => {
    const {updateLayout} = useContext(LayoutContext);
    useEffect(() => {
        updateLayout(l);
    });
};

export const LayoutContextProvider = ({children}) => {
    const [layout, setLayout] = useState(LayoutDefine.main);
    const updateLayout = (l) => {
        setLayout(l);
    };
    return (<LayoutContext.Provider value={{layout, updateLayout}}>{children}</LayoutContext.Provider>);
};
